<template>
  <Transition :name="animation" mode="out-in">
    <slot></slot>
  </Transition>
</template>

<script setup>
import {ref, watch} from "vue";

const props = defineProps({
  transitionKey: Number,
  fadeTransitionKey: Boolean,
});

const animation = ref("slide-down");

watch(() => props.transitionKey, (newVal, oldVal) => {
  const isCountingUp = !oldVal || newVal > oldVal;
  const isSameStep = newVal === oldVal;

  if (isSameStep) animation.value = "fade";
  else if (isCountingUp) animation.value = "slide-up";
  else animation.value = "slide-down";
});

watch(() => props.fadeTransitionKey, () => {
  animation.value = "fade";
});

</script>

<style scoped>
/* slide up */
.slide-up-enter-active {
  transition: all 0.25s;
}

.slide-up-leave-active {
  transition: all 0.25s;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(80vh);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-80vh);
}

/* slide down */
.slide-down-enter-active {
  transition: all 0.25s;
}

.slide-down-leave-active {
  transition: all 0.25s;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-80vh);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(80vh);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
